<template>
	<div>
		<div class="detail" >
			<div class="product_info">
				<div class="title">Product details</div>
				<div class="info flex align-center" v-for="(item,index) in detail.goods" :key="index">
					<div class="picture">
						<img :src="imgBaseUrl + item.image" alt="">
					</div>
					<div class="intro">
						<div class="name">{{item.name}}</div>
						<div class="num">{{item.num}}</div>
						<div class="price">{{item.total_price}}</div>
					</div>
				</div>
			</div>
			<div class="order_info">
				<div class="title">Order Detailss</div>
				<div class="order_list">
					<div class="order_item">
						<span>Order Number:</span>
						<span class="val">{{detail.order_sn}}</span>
					</div>
					<div class="order_item">
						<span>Order time:</span>
						<span class="val">{{detail.createtime}}</span>
					</div>
					<div class="order_item">
						<span>Order status:</span>
						<span class="val">{{detail.order_status_txt}}</span>
					</div>
					<div class="order_item">
						<span>Payment Method:</span>
						<span class="val">{{detail.pay_type}}</span>
					</div>
				</div>
				
				<div class="submit" v-if="detail.order_status == 0" @click="toPay">Proceed to checkout</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				detail:{},
				order_sn:''
			}
		},
		created(){
			this.order_sn = this.$route.query.order_sn;
			this.getDetail();
		},
		methods:{
			toPay(){
				this.$api.post('pay/stripe',{order_sn:this.order_sn,type:'pc'},res=>{
					if(res.code == 1){
						// this.$message('pay success')
						// this.$router.push('/home/userInfo/orderList')
						location.href=res.data.url
					}
				})
			},
			getDetail(){
				this.$api.post('order/getOrderDetails',{order_sn:this.order_sn},res=>{
					if(res.code == 1){
						res.data.order_status_txt = res.data.order_status == 0 ? 'To be paid' : res.data.order_status == 1 ? 'To be signed in' :res.data.order_status == 2 ? 'completed' : 'Cancelled'
						this.detail = res.data;
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.detail{
		width: 1240px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
		border-radius: 10px;
		margin-top: 30px;
		margin-left: 20px;
		padding: 40px;
		.product_info{
			.title{
				font-size: 24px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				margin-bottom: 30px;
			}
			.info{
				width: 100%;
				padding-bottom: 40px;
				border-bottom: 1px solid #5C707A;
				position: relative;
				.picture{
					width: 228px;
					height: 213px;
					background: #282E30;
					border-radius: 10px;
					overflow: hidden;
					flex-shrink: 0;
					// position: absolute;
					// left: 0;
					// top: 0;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.intro{
					width: 100%;
					padding-left: 30px;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 30px;
					.num{
						text-align: right;
						margin-top: 20px;
					}
					.price{
						margin-top: 30px;
					}
				}
			}
		}
		.order_info{
			padding-bottom: 100px;
			.title{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				padding-top: 40px;
			}
			.order_list{
				display: flex;
				flex-wrap: wrap;
			}
			.order_item{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				line-height: 60px;
				margin-right: 100px;
				.val{
					color: #BF5F49;
				}
			}
			.submit{
				width: 182px;
				height: 58px;
				background: #5C707A;
				border-radius: 29px;
				text-align: center;
				line-height: 58px;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #F7F2EB;
				float: right;
				cursor: pointer;
			}
		}
	}
</style>